import type { PendingClientImportsCountResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ClientImportAlertsGateway } from './client-import-alerts.gateway';

/** Real implementation over the shared api client (`api.get` unwraps `{ success, data }`). */
export const httpClientImportAlertsGateway: ClientImportAlertsGateway = {
  loadPendingCount: async () =>
    (await api.get<PendingClientImportsCountResponse['data']>('/admin/client-imports/pending-count'))
      .count,
};
